import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import PaiButton from '../../ui/base-components/pai-button';

interface Props {
  open: boolean;
  issues: string[];

  handleClose: () => void;
}

const StartingCampaignNotPossibleDialog: React.FC<Props> = ({ open, issues, handleClose }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'sm'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('startingCampaignNotPossibleDialogTitle')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={1}>
          <Typography className={classes.text}>{t('startingCampaignNotPossibleDialogContent1')}</Typography>
          <Typography className={classes.text} fontWeight={'bold'}>
            {t('startingCampaignNotPossibleDialogContent2')}
          </Typography>
          {issues.map((issue, index) => (
            <Typography key={index} className={classes.text} component={'li'}>
              {issue}
            </Typography>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiButton text={t('ok')} size={'small'} border={'rounded'} action={handleClose} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: 'linear-gradient(to right, #5044FF, #4AA4FF)',
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '24px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
  warningText: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
}));

export default StartingCampaignNotPossibleDialog;
